import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { CoolerCpu } from '../model/CoolerCpu';
import { Mother } from '../model/Mother';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_CoolerCpuMother extends FuncionCompatilibidadBase<CoolerCpu, Mother> {
  funciones = {
    socket: (coolerCpu: CoolerCpu, mother: Mother): Incompatibilities | null =>
      (
        coolerCpu.$caracteristicas?.sockets
          ?.split(',')
          .some((socket) => mother.$caracteristicas?.anclaje.split(',').includes(socket))
      ) ?
        null
      : {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility:
            'Los sockets de la mother son incompatibles con los sockets del coolercpu',
        },
  };
}
